function setRecoverySnackbarError({ state }) {
  state.merge('login.recovery.snackbar', { show: true, success: false })
}

export default setRecoverySnackbarError



// WEBPACK FOOTER //
// ./src/modules/login/actions/setRecoverySnackbarError.js